export default "__VITE_ASSET__5c4c7e16__"